import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Conditional class names — never string concatenation, never inline styles. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
